import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import RequestsStore                from  '@/store/modules/Requests'

import LayoutsStore                 from  '@/store/modules/Layouts'
import flashMessageStore            from  '@/store/modules/FlashMessage'
import globalLoadingStore           from  '@/store/modules/GlobalLoading'

import PATimesModalStore            from  '@/store/modules/PATimesModal'

import timesFlashLineStore          from  '@/store/modules/TimesFlashLine'
import ModalStore                   from  '@/store/modules/Modal'

import UserStore                    from  '@/store/modules/User'
import CharacterStore               from  '@/store/modules/Character'
import CharacterLevelStore          from  '@/store/modules/CharacterLevel'
import KnownCharacterStore          from  '@/store/modules/KnownCharacter'
import AuthenticationStore          from  '@/store/modules/Authentication'

import MessageStore                 from  '@/store/modules/Message'

import StoryBookStore               from  '@/store/modules/StoryBook'

import ConnectionStore              from  '@/store/modules/Connection'
import ConnectionManageModalStore   from  '@/store/modules/ConnectionManageModal'
import ConnectionLeaveModalStore    from  '@/store/modules/ConnectionLeaveModal'

import PhotoSwipeStore              from  '@/store/modules/PhotoSwipe'

import CreateButtonStore            from  '@/store/modules/CreateButton'

import ItemUseModalStore            from '@/store/modules/ItemUseModal'

import ParkListStore                from '@/store/modules/ParkList'
import ParkNoteDeleteModal          from '@/store/modules/ParkNoteDeleteModal'

import ParkNoteCommentStore         from  '@/store/modules/ParkNoteComment'

import ParkNoteStore                from '@/store/modules/ParkNote'

import CharacterApplicationDetailModalStore from '@/store/modules/CharacterApplicationDetailModal'

import TextEditorWarningModalStore  from '@/store/modules/TextEditorWarningModal'

import TutorialStore                from '@/store/modules/Tutorial'

export default new Vuex.Store({
  modules: {
    'requests'              : RequestsStore,

    'layouts'               : LayoutsStore,
    'flashMessage'          : flashMessageStore,
    'globalLoading'         : globalLoadingStore,
    
    'paTimesModal'          : PATimesModalStore,

    'timesFlashLine'        : timesFlashLineStore,
    'modal'                 : ModalStore,

    'user'                  : UserStore,
    'character'             : CharacterStore,
    'characterLevel'        : CharacterLevelStore,
    'knownCharacter'        : KnownCharacterStore,
    'authentication'        : AuthenticationStore,
    'message'               : MessageStore,

    'storyBook'             : StoryBookStore,

    'connection'            : ConnectionStore,
    'connectionManageModal' : ConnectionManageModalStore,
    'connectionLeaveModal'  : ConnectionLeaveModalStore,

    'photoSwipe'            : PhotoSwipeStore,

    'createButton'          : CreateButtonStore,

    'itemUseModal'          : ItemUseModalStore,
    
    'parkList'              : ParkListStore,
    'parkNoteDeleteModal'   : ParkNoteDeleteModal,
    'parkNoteComment'       : ParkNoteCommentStore,
    'parkNote'              : ParkNoteStore,

    'characterApplicationDetailModal'  : CharacterApplicationDetailModalStore,

    'textEditorWarningModal'  : TextEditorWarningModalStore,

    'tutorial'                : TutorialStore
  },

  state: {
    routingPosition   : 'home',
    pageTitle         : 'ホーム',
    
    applicationDataFetchDate  : null,
  },

  mutations: {
    setRoutingPosition(state, position){
      state.routingPosition = position;
    },
    
    setPageTitle(state, value){
      state.pageTitle = value;
    },

    setApplicationDataFetchDate(state, value){
      state.applicationDataFetchDate = value;
    }
  },

  actions: {
    updateRoutingPosition(context, payload){
      context.commit('setRoutingPosition', payload.position);
    },

    updatePageTitle(context, payload){
      context.commit('setPageTitle', payload.title);
    },

    updateApplicationDataFetchDate(context, payload){
      context.commit('setApplicationDataFetchDate', payload.data);
    },

    clearAllStore(context){
      context.dispatch('authentication/resetStore');
      context.dispatch('character/resetStore');
      context.dispatch('characterApplicationDetailModal/resetStore');
      context.dispatch('characterLevel/resetStore');
      context.dispatch('connection/resetStore');
      // context.dispatch('connectionLeaveModal/resetStore');
      // context.dispatch('connectionManageModal/resetStore');
      // context.dispatch('createButton/resetStore');
      // context.dispatch('flashMessage/resetStore');
      // context.dispatch('globalLoading/resetStore');
      // context.dispatch('itemUseModal/resetStore');
      context.dispatch('knownCharacter/resetStore');
      context.dispatch('message/resetStore');
      context.dispatch('parkList/resetStore');
      context.dispatch('parkNote/resetStore');
      context.dispatch('parkNoteComment/resetStore');
      // context.dispatch('parkNoteDeleteModal/resetStore');
      // context.dispatch('paTimesModal/resetStore');
      context.dispatch('photoSwipe/resetStore');
      context.dispatch('timesFlashLine/resetStore');
      context.dispatch('user/resetStore');

      console.log('clear all data.');
    },

    systemLogout(context){
      context.dispatch('authentication/logout');

      context.dispatch('clearAllStore');
    },

    async systemLeaveLogout(context){
      await context.dispatch('authentication/clearFrontendLogoutData');

      await context.dispatch('clearAllStore');
    }
  }
})
